export default "__VITE_ASSET__DIM9fxtu__"